import {
  Form,
  ButtonToolbar,
  Button,
  Message,
  Modal,
  Stack,
  Divider,
  Toggle
} from 'rsuite';
import serviceTermPdf from '/SD-FortiSOC-Cloud.pdf';
import {
  Apploader,
  ProvisionConfirm,
  RegionSelector,
  TimezoneSelector,
  globalApi,
  useAppDispatch,
  useAppSelector,
  useLazyCheckPreProvisionQuery,
  useProvisionMutation
} from '@monorepo/shared';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { ProvisionCols, server } from '../../config/const';
import RemindOutlineIcon from '@rsuite/icons/RemindOutline';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { ProvisionSocDetail } from './ProvisionSocStatus';
import ProvisionIcon from '../../images/account/provision.svg';
import { selectRegions } from '@monorepo/shared/store/authSlice';
import { ProvisionFailureTicket } from './AccountDetail';
interface IProvisionProps {
  sn?: string;
  region_alias?: string;
}

export const ProvisionForm = ({ sn, region_alias }: IProvisionProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const regions = useAppSelector(selectRegions);
  const [checkPreProvision, { data: ticket }] = useLazyCheckPreProvisionQuery();
  const [taskObj, setTaskObj] = useState<Record<string, any>>({});
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [hasTicket, setHasTicket] = useState<boolean>(false);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [region, setRegion] = useState<Record<string, any>>({
    rawValue: '',
    label: ''
  });
  const [showImageVersion, setShowImageVersion] = useState<boolean>(true);
  const [showAdomVersion, setShowAdomVersion] = useState<boolean>(false);
  const [imageVersion, setImageVersion] = useState<string>('');
  const [adomVersion, setAdomVersion] = useState<string>('');
  const [timezone, setTimezone] = useState<Record<string, any> | undefined>({
    label: '',
    rawValue: ''
  });
  const setSelectedRegion = (selectedItem?: Record<string, any>) => {
    setShowImageVersion(selectedItem?.enableImageVersion);
    setShowAdomVersion(selectedItem?.enableAdomVersion);
    !selectedItem?.enableImageVersion && setImageVersion('');
    selectedItem && setRegion(selectedItem);
  };

  const setSelectedImageVersion = (selectedValue?: string) => {
    setImageVersion(selectedValue || '');
  };

  const setSelectedAdomVersion = (selectedValue?: string) => {
    setAdomVersion(selectedValue || '');
  };
  // const setSelectedTimezone = (selectedItem?: Record<string, any>) => {
  //   selectedItem && setTimezone(selectedItem);
  // };
  // timezone can clear default value to set empty, so change the type of selectedItem to any
  const setSelectedTimezone = (
    selectedItem: Record<string, any> | undefined
  ) => {
    setTimezone(selectedItem);
  };
  const [message, setMessage] = useState<string>('');
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [isMultiTenant, setIsMultiTenant] = useState<boolean>(false);
  const [showMultiTenantConfirm, setShowMultiTenantConfirm] =
    useState<boolean>(false);
  const [provisionInstance, getTaskIdResult] = useProvisionMutation();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const getRequiredProps = useCallback(() => {
    const obj: Record<string, any> = {
      region: {
        value: region?.rawValue,
        errorMessage: `${t('common.provision.regionRequire')}`
      }
    };
    if (ProvisionCols.includes('timezone')) {
      return {
        ...obj,
        timezone: {
          value: timezone?.rawValue,
          errorMessage: `${t('common.provision.timezoneRequire')}`
        }
      };
    }
    return obj;
  }, [timezone, region]);
  const checkError = useCallback(() => {
    setMessage('');
    const messages: Array<string> = [];
    const requiredProps: Record<string, any> = getRequiredProps();
    Object.values(requiredProps).map((obj) => {
      if (!obj?.value) {
        messages.push(obj?.errorMessage);
      }
    });
    if (messages.length) {
      setShowMessage(true);
      setMessage(messages.join('|'));
    } else {
      setShowMessage(false);
      setDialogOpen(true);
    }
  }, [getRequiredProps]);

  useEffect(() => {
    if (ticket?.type === 'EXIST_TICKET') {
      setHasTicket(true);
    } else {
      setHasTicket(false);
    }
  }, [ticket]);

  useEffect(() => {
    if (getTaskIdResult.error) {
      const data: Record<string, any> = getTaskIdResult.error;
      const code = data?.data?.error_code || data?.status;
      const message = data?.data?.error_desc || data?.data?.message;
      if (message && setMessage) {
        setMessage(`${message} [Error_code: ${code}]`);
        setShowMessage(true);
      }
    } else if (getTaskIdResult.data) {
      const data: Record<string, any> = getTaskIdResult.data;
      if (data?.task_id) {
        setTaskObj({ task_id: data.task_id, region_alias: region.rawValue });
      } else if (data?.login_url) {
        console.warn('This instance already has url exists', data?.login_url);
        setMessage(
          'This license SN already provisioned. Login url : ' + data?.login_url
        );
        setShowMessage(true);
      } else if (data?.error_desc && setMessage) {
        setMessage(`${data?.error_desc} [Error_code: ${data?.error_code}]`);
        setShowMessage(true);
      }
    }
  }, [getTaskIdResult]);

  useEffect(() => {
    if (sn && region_alias) {
      setIsCheck(true);
    } else if (taskObj.task_id && taskObj.region_alias) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
  }, [region_alias, taskObj, sn]);

  return (
    <Stack
      spacing={'30px'}
      className="provision-container"
      alignItems="flex-start"
    >
      <Stack.Item>
        <img src={ProvisionIcon} className="service-icon" />
      </Stack.Item>
      <Stack.Item flex={1} className="info-content">
        <div className="service-title">{' Provision Service '}</div>
        {getTaskIdResult.isLoading ? (
          <div style={{ height: '90%', position: 'relative' }}>
            <Apploader labelText={'Loading...'} />
          </div>
        ) : isCheck ? (
          <ProvisionSocDetail
            sn={sn === 'trial' ? undefined : sn}
            task_id={taskObj.task_id}
            account_id={currentAccount?.account_id}
            region_alias={region_alias || taskObj.region_alias}
            callBack={() => {
              setIsCheck(false);
              const queryRegion = regions[region_alias || taskObj.region_alias];
              if (currentAccount?.account_id && queryRegion?.token) {
                checkPreProvision({
                  account_id: currentAccount?.account_id,
                  region: queryRegion
                });
                setHasTicket(true);
              }
            }}
          ></ProvisionSocDetail>
        ) : hasTicket ? (
          <ProvisionFailureTicket />
        ) : (
          <>
            {showMessage ? (
              <Message
                showIcon
                closable
                onClose={() => {
                  setShowMessage(false);
                  setMessage('');
                }}
                type="error"
                header="A problem occurred:"
                style={{ marginBottom: '20px' }}
              >
                <ul>
                  {message.split('|')?.map((str: string, index: number) => (
                    <li key={index}>{str}</li>
                  ))}
                </ul>
              </Message>
            ) : (
              <></>
            )}
            <Form layout="horizontal">
              <Form.Group controlId="region" aria-required>
                <Form.Label>{t('common.provision.region')}</Form.Label>
                <div className={'rs-form-control-wrapper'}>
                  <RegionSelector
                    onSelectHandle={setSelectedRegion}
                    server={server}
                    enableTimezone={true}
                    onRegionLoginErrorHandle={(region) => {
                      setMessage(`Region login failed: ${region?.name} `);
                      setShowMessage(true);
                    }}
                  />
                </div>
              </Form.Group>
              {ProvisionCols.includes('timezone') ? (
                <Form.Group controlId="timezone">
                  <Form.Label>{t('common.provision.timezone')}</Form.Label>
                  <div className={'rs-form-control-wrapper'}>
                    <TimezoneSelector
                      region={region?.rawValue}
                      onSelectHandle={setSelectedTimezone}
                    />
                  </div>
                </Form.Group>
              ) : (
                <></>
              )}
              <Divider size="xs" />

              <Form.Group controlId="isMultiTenant">
                <Form.Label style={{ width: '100%' }}>
                  {'Multi-tenancy'}
                  <div style={{ opacity: 0.8 }}>
                    {
                      'Serves multiple customers or business units from this instance'
                    }
                  </div>
                </Form.Label>
                <div className={'rs-form-control-wrapper'}>
                  <Toggle
                    size={'xs'}
                    checked={isMultiTenant}
                    onChange={(checked) => {
                      if (checked) {
                        setShowMultiTenantConfirm(true);
                      } else {
                        setIsMultiTenant(false);
                      }
                    }}
                  />
                </div>
              </Form.Group>
              <ButtonToolbar style={{ marginTop: '20px' }}>
                <Button
                  appearance="ghost"
                  className="action-btn"
                  onClick={() => {
                    dispatch(globalApi.util.invalidateTags(['Regions']));
                    setIsMultiTenant(false);
                  }}
                >
                  Reset
                </Button>
                <Button
                  appearance="primary"
                  className="action-btn"
                  onClick={checkError}
                >
                  {t('common.provision.submit')}
                </Button>
              </ButtonToolbar>
              <div style={{ height: '80px' }}></div>
            </Form>
            <ProvisionConfirm
              requiredProps={getRequiredProps()}
              dialogOpen={dialogOpen}
              setDialogOpen={setDialogOpen}
              rowData={{ account_id: currentAccount.account_id }}
              timezone={timezone || { label: '', rawValue: '', value: '' }}
              region={region}
              imageVersion={imageVersion}
              adomVersion={adomVersion}
              provisionInstance={provisionInstance}
              pdf={serviceTermPdf}
              server={server}
              is_soc={true}
              isMultiTenant={isMultiTenant}
            ></ProvisionConfirm>
            <Modal
              size="xs"
              centered
              overflow={false}
              backdrop="static"
              role="alertdialog"
              open={showMultiTenantConfirm}
              onClose={() => setShowMultiTenantConfirm(false)}
              className="multi-tenant-confirm"
            >
              <Modal.Header>
                <Modal.Title>
                  <RemindOutlineIcon
                    style={{
                      color: 'var(--fsr-btn-border)',
                      marginRight: '10px'
                    }}
                  />
                  {'Enable Multi-tenancy?'}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {
                  'Multi-tenancy settings cannot be changed after provisioning. Reversing them means re-provisioning the service and losing existing tenant data.'
                }
              </Modal.Body>
              <Modal.Footer>
                <Button
                  size="sm"
                  appearance="ghost"
                  onClick={() => setShowMultiTenantConfirm(false)}
                >
                  {'Cancel'}
                </Button>
                <Button
                  size="sm"
                  appearance="primary"
                  onClick={() => {
                    setIsMultiTenant(true);
                    setShowMultiTenantConfirm(false);
                  }}
                >
                  {'Enable Multi-tenancy'}
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Stack.Item>
    </Stack>
  );
};
